import fetch from 'isomorphic-fetch';
import { AreenaApiRequiredParams } from '../appTypings';
import { isAreenaUrl } from '../../service/areena-api/fetchers';
import { YleApiCredentials } from 'src/common/types';
import { withQuery } from '../../common/utils';

export type AuthFetch = typeof fetch;

/**
 * @deprecated use fetchers under services for example areenaApiFetcher
 * @param authInit
 * @param yleApiCredentials
 * @param areenaApiRequiredParams
 * @returns {{(input: (RequestInfo | URL), init?: RequestInit): Promise<Response>, (input: (RequestInfo | URL), init?: RequestInit): Promise<Response>} & _fetch & {authenticated: boolean}}
 */
export const authFetch = (
  authInit: RequestInit,
  yleApiCredentials?: YleApiCredentials,
  areenaApiRequiredParams?: AreenaApiRequiredParams
): AuthFetch => {
  const fetchWithCredentials: typeof fetch = (resource, init) => {
    const url =
      typeof resource === 'string'
        ? resource
        : resource instanceof Request
          ? resource.url
          : resource.toString();

    const config = { ...authInit, ...init };
    const extraParams = isAreenaUrl(url) ? areenaApiRequiredParams : {};

    return fetch(
      withQuery(url, {
        ...extraParams,
        app_id: yleApiCredentials?.id ?? '',
        app_key: yleApiCredentials?.key ?? '',
      }),
      config
    );
  };

  return Object.assign(fetchWithCredentials, { authenticated: true });
};

export const includeCredentials: RequestInit = {
  credentials: 'include',
};
